import { ERRORS_DICTIONARY } from '@constants/errors';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { t } from './strings';

export function getErrorMessage(
  err: any,
  translate: TranslateService
): Observable<string | any> {
  let errMsg = ERRORS_DICTIONARY[err.name];
  try {
    if (errMsg) {
      if (err.name === 'InvalidParameterException') {
        if (err.message.includes('email')) {
          errMsg += 'Email format is incorrect.';
        } else if (err.message.includes('phone number')) {
          errMsg +=
            'Phone number format is incorrect. Please make sure to include your country code.';
        } else if (err.message.includes('company')) {
          errMsg += 'Company must be 3-50 characters long.';
        } else {
          errMsg += 'Please check your input.';
        }
      } else if (err.name === 'InvalidPasswordException') {
        if (err.message.includes('long')) {
          errMsg += 'Password must be 8-256 characters long.';
        } else if (err.message.includes('uppercase')) {
          errMsg += 'Password must include uppercase letters.';
        } else if (err.message.includes('lowercase')) {
          errMsg += 'Password must include lowercase letters.';
        } else if (err.message.includes('numeric')) {
          errMsg += 'Password must include a number.';
        } else if (err.message.includes('symbol')) {
          errMsg +=
            'Password must include a special character (e.g., !@#$%^&*()).';
        } else {
          errMsg +=
            'Password must be 8-256 characters long, include uppercase and lowercase letters, a number, and a special character.';
        }
      }
    } else {
      errMsg = err.message;
    }
  } catch (e) {
    errMsg = err;
  }
  return t('commons', `${errMsg}`, translate);
}
